import type { Features, Ticker } from '@cutr/constants/cutlist-theme.ts';

export const CONFIGURATOR_ROUTE = 'configurator';

export const liveThemes: Ticker[] = [
  'CUTR',
  'BNB',
  'STIHO',
  'VERDOUW',
  'BOUWPROFI',
  'SWISSKRONO',
];

export type Meta = {
  title: string;
  component: () => React.JSX.Element;
  argTypes: Record<keyof Features, ArgType>;
  config: {
    args: Args;
    decorators: ((story: React.FC, context: Args) => React.FC)[];
  };
};

export type Args = {
  theme: Ticker;
  isEnabled?: boolean;
} & Features;

export type ArgType =
  | { control: 'boolean' }
  | { control: 'number' }
  | { control: 'select'; options: string[] }
  | { control: 'text' };
